import axios from 'axios'
import qs from 'qs'

export const trackEvent = async (parameters) => {
  try {
    const instance = axios.create()
    delete instance.defaults.headers.common.Authorization
    await instance.post(
      'https://trackcmp.net/event',
      // JSON.stringfy estava dando error de cors, pela doc do Axios ele recomenda essa lib
      // para reqs x-www-form-urlencoded
      qs.stringify({
        key: `${process.env.REACT_APP_ACTIVE_CAMPAIGN_KEY}`,
        event: parameters.event,
        actid: `${process.env.REACT_APP_ACTIVE_CAMPAIGN_ID}`,
        eventdata: parameters.eventdata,
        visit: `{"email": "${parameters.email}"}`,
      }),
      {
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    )
    return
  } catch (error) {
    console.error(error)
  }
}
